import React from 'react';
//import PropTypes from 'prop-types';
import { DropTarget } from 'react-dnd';

//import Separator from './Separator';
import { connect } from '../../utils';

const target = {
  drop(props, monitor, component) {
    if (!monitor.didDrop()) {
      props.layoutState.insertOrMoveItem(props.id, props.children.length, monitor.getItem());
    }
  }
};

let renderText = (value, containerPadding, lineHeight,letterSpacing) => {
    return <div style={{padding:containerPadding, lineHeight, letterSpacing, width:'100%', textAlign: 'left'}} dangerouslySetInnerHTML={{__html:value}} />;
  }

const EditLayout = ({ id, children, isOverCurrent, connectDropTarget, type, layoutState, readOnly }) => {
  const {containerPadding, text, lineHeight, backgroundColor, letterSpacing} = layoutState.getItemJS(id).props.values;
  return connectDropTarget(
    <div style={{
      boxSizing: 'border-box',
      position: 'relative',
      height: '100%',
      backgroundColor,
      display: 'flex',
      flex:1
    }}>
      {renderText(text, containerPadding, lineHeight, letterSpacing)}
    </div>
  );
};

const LayoutContainer = DropTarget('TextView', target, (conn, monitor) => ({
  connectDropTarget: conn.dropTarget(),
  isOverCurrent: monitor.isOver({shallow: true})
}))(EditLayout);

export default connect('layoutState', 'readOnly')(LayoutContainer);

// export default LayoutContainer;s



// WEBPACK FOOTER //
// ./src/editor/layout/components/Layout/DnDText.js